"use client";

import { NamespaceIcon } from "@/components/scirix/namespace-icon";
import { useWorkspaceRouteNamespace } from "@/components/workspaces/workspace-route-context";
import { useActiveNamespaceId, useNamespacesQuery } from "@/hooks/useNamespaces";
import { useOptionalSession } from "@/hooks/useSession";
import { cn } from "@/lib/utils";

export function TopBarNamespaceIndicator() {
  const sessionContext = useOptionalSession();

  if (!sessionContext || sessionContext.session.status !== "authenticated") {
    return null;
  }

  return <TopBarNamespaceIndicatorContent />;
}

function TopBarNamespaceIndicatorContent() {
  const namespacesQuery = useNamespacesQuery();
  const ambientNamespaceId = useActiveNamespaceId();
  const routeNamespace = useWorkspaceRouteNamespace();
  const namespaceId = routeNamespace ? routeNamespace.namespaceId : ambientNamespaceId;

  const active = namespaceId
    ? namespacesQuery.data?.find((ns) => ns.namespaceId === namespaceId)
    : undefined;

  if (!active) {
    return null;
  }

  return (
    <div
      className={cn(
        "inline-flex min-w-0 max-w-[280px] items-center gap-1.5 rounded-full border border-border/40 px-3 py-1 text-sm",
        "bg-[color-mix(in_oklab,var(--token-surface-default)_8%,transparent)]",
      )}
      aria-label={`Active namespace: ${active.name}`}
      title={active.organizationName ? `${active.name} · ${active.organizationName}` : active.name}
    >
      <NamespaceIcon
        icon={active.icon}
        name={active.name}
        className="h-4 w-4 rounded-[4px] text-base"
      />
      <span className="truncate font-medium text-foreground">{active.name}</span>
    </div>
  );
}
